import { Home } from "./components/Home";                                   /*Ȩ*/
import { NoAuthencation } from './components/NoAuthencation';               /*���Ѿ���*/

import { Index as LoginMgr } from './components/Account/LoginMgr/Index';    /*�α���*/
import { Index as MemberMgr } from './components/Account/MemberMgr/Index';  /*ȸ������*/
import { Index as Notice } from './components/MyPage/Notice/Index';         /*��������*/
import { Index as Goods } from './components/Search/Goods/Index';           /*��ǰ�˻�*/
import { Index as Basket } from './components/MyPage/Basket/Index';         /*��ٱ���*/
import { Index as MyInfoMgr } from './components/MyPage/MyInfoMgr/Index';   /*����������*/
import { Index as BookMark } from './components/MyPage/BookMark/Index';     /*���ѻ�ǰ*/
import { Index as ProcessMgr } from './components/MyPage/ProcessMgr/Index';     /*�ŷ�����*/
import { Index as OrderMgr } from './components/MyPage/OrderMgr/Index';     /*�ŷ�����*/
import { Index as Store } from './components/Order/Store/Index';            /*�ֹ��ϱ�*/
import { Index as ChatList } from './components/Chat/ChatList/Index';       /*ä�ø���Ʈ*/

import { Index as AdMgr } from './components/AdMgr/Index';                  /*����������*/
import { SepecialEvent } from './components/AdMgr/SepecialEvent';           /*������̺�Ʈ*/
import { ListGoodsMore } from './components/AdMgr/ListGoodsMore';           /*������̺�Ʈ*/
import { Success } from './components/Common/Success';                      /*����������*/
import { Fail } from './components/Common/Fail';                            /*����������*/

import { LiveChatList } from './components/Chat/LiveChat/LiveChatList';     /*���̺� ä�ø���Ʈ*/
import { Index as LiveChatDig } from './components/Chat/LiveChat/Index';    /*���̺� ä��*/

import { SimilarGoods } from './components/Search/Similar/SimilarGoods'; /*�ܺ� ��ǰ ���絵 �˻�*/

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/NoAuthencation',
        element: <NoAuthencation />
    },
    {
        path: '/Account/LoginMgr/Index',
        element: <LoginMgr />
    },
    {
        path: '/Account/MemberMgr/Index',
        element: <MemberMgr />
    },
    {
        path: '/MyPage/Notice/Index',
        element: <Notice />
    },
    {
        path: '/Search/Goods/Index',
        element: <Goods />
    },
    {
        path: '/MyPage/Basket/Index',
        element: <Basket />
    },
    {
        path: '/Success',
        element: <Success />
    },
    {
        path: '/Fail',
        element: <Fail />
    },
    {
        path: '/MyPage/MyInfoMgr/Index',
        element: <MyInfoMgr />
    },
    {
        path: '/MyPage/BookMark/Index',
        element: <BookMark />
    },
    {
        path: '/MyPage/OrderMgr/Index',
        element: <OrderMgr />
    },
    {
        path: '/MyPage/ProcessMgr/Index',
        element: <ProcessMgr />
    },
    {
        path: '/Order/Store/Index',
        element: <Store />
    },
    {
        path: '/Chat/ChatList/Index',
        element: <ChatList />
    },
    {
        path: '/AdMgr/Index',
        element: <AdMgr />
    },
    {
        path: '/Chat/LiveChat/LiveChatList',
        element: <LiveChatList />
    },
    {
        path: '/Chat/LiveChat/Index',
        element: <LiveChatDig />
    },
    {
        path: '/AdMgr/SepecialEvent',
        element: <SepecialEvent />
    },
    {
        path: '/AdMgr/ListGoodsMore',
        element: <ListGoodsMore />
    },
    {
        path: '/Search/Similar/SimilarGoods',
        element: <SimilarGoods />
    }
];

export default AppRoutes;
